export const RESULT_SHOWING_TIME = 5000;

export const GAME_NUM_PAD_BUTTON_VALUE = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0];

export const MIN_ODD = 1.01;

export const maxOddValue = 10000;

export const INFINITY_AUTO_BET = 'infinity';

export const AUTO_BET_COUNTS = [100, 50, 25, 10, 5, 0];

export const GAME_LOADER_DOT_COUNT = new Array(8).fill(null).map((item, index) => index);

export const GAME_CONTROLLER_TYPES_YET = {
  BETS: 'BETS',
  RESULT_HISTORY: 'RESULT_HISTORY',
};

export const CRAZY_WORM_GAME_TYPE_ID = 241;

export const CRAZY_WORM_GAME_ID = 25;

export const specificLocalStorageKeys = {
  isTurboModePopUp: 'isTurboModePopUp',
};

export const betSectionIndex = {
  firstIndex: 0,
  secondIndex: 1,
};
